import { FunctionComponent } from 'react';
import './styles/NoticeThemeSwatch.scss';

import { Box } from '@mui/material';

import { INoticeThemeStyle, noticeThemeBorderSx } from '@dw/models/notice';
import { componentClassName } from '@dw/utils';

interface INoticeThemeSwatchProps {
  style: INoticeThemeStyle;
  /** The compact form used beside a row on the board, rather than inside a picker. */
  small?: boolean;
}

/**
 * A square of the actual notice colour — paper and edge both.
 *
 * The colour is the only honest way to show this choice; a theme's name ("Butter", "Recital gold")
 * is a label for something you have to see. It draws the theme's own border when the theme has one,
 * and falls back to a faint outline when it does not, so the palest themes still read as a swatch
 * rather than as a hole in the page.
 */
export const NoticeThemeSwatch: FunctionComponent<INoticeThemeSwatchProps> = (props: INoticeThemeSwatchProps) => {

  const { style, small } = props;

  const cn = componentClassName('notice-theme-swatch');

  return (
    <Box
      className={small ? cn('small') : cn()}
      sx={{
        backgroundColor: style.backgroundColor,
        // A theme with no border of its own still needs an outline here, or a near-white swatch
        // vanishes into the dialog behind it. The SCSS holds that default; this only overrides it
        // when the studio has actually chosen a border.
        ...noticeThemeBorderSx(style)
      }}
      aria-hidden
    />
  );
};
